import { PrescriptionDrug } from './prescription-drug';
import { PrescriptionSelectDrug } from './prescription-select-drug';

export class Prescription {
  constructor() {
    this.drugs = [];
    this.originalDrugs = [];
    this.selectDrug = [];
  }

  public prescriptionId?: string;
  public drugs: PrescriptionDrug[];
  
  public originalDrugs: PrescriptionDrug[];
  public selectDrug: any[];
}
